<!-- 兑换信息 -->
<template>
    <div class="exchangeMsg">
        <div class="goods_msg">
            <div class="left_img">
                <img :src="goodsMsg.kmccoverurl" alt="">
            </div>
            <div class="right_msg">
                <p class="title">{{goodsMsg.kmcname}}</p>
                <p class="type">{{goodsMsg.kmctypename}}</p>
            </div>
        </div>
        <div class="price_validity">
            <div class="item" v-if="goodsMsg.uprice > goodsMsg.saleprice">
                <div class="left_label">商品原价</div>
                <div class="right_value">￥{{goodsMsg.uprice}}</div>
            </div>
            <div class="item">
                <div class="left_label">商品现价</div>
                <div class="right_value">￥{{goodsMsg.saleprice}}</div>
            </div>
            <div class="item">
                <div class="left_label">兑换有效期</div>
                <div class="right_value">{{goodsMsg.kmcexpiretime}}</div>
            </div>
        </div>
        <div class="btn_box">
            <van-button @click="uploadRedeemcodeInfo">确认兑换</van-button>
        </div>
    </div>
</template>

<script>
import {validationRedeemcodeInfo, uploadRedeemcodeInfo} from 'api/personalCenterApi'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            codevalue: this.$route.query.codevalue ? this.$route.query.codevalue : '',
            goodsMsg: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.validationRedeemcodeInfo()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        
    },
    methods: {
        validationRedeemcodeInfo() {
            this.setLoading(true)
            validationRedeemcodeInfo({
                data: {codevalue: this.codevalue},
                success: res => {
                    this.setLoading(false)
                    this.goodsMsg = res.data
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        uploadRedeemcodeInfo() {
            this.setLoading(true)
            uploadRedeemcodeInfo({
                data: {kmcinnerid: this.goodsMsg.kmcinnerid, kmctype: this.goodsMsg.kmctype, ordermoney: this.goodsMsg.saleprice, redeemcodevalue: this.codevalue},
                success: () => {
                    this.setLoading(false)
                    this.$toast.success('兑换成功')
                    let that = this
                    setTimeout(() => {
                        that.$router.back()
                    }, 1000)
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])   
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .exchangeMsg {
        .goods_msg {
            display: flex;
            padding: 0.32rem;
            background: #fff;
            margin-bottom: 0.2rem;
            .left_img {
                width: 2.6rem;
                height: 1.45rem;
                margin-right: 0.2rem;
                img {
                    width: 2.6rem;
                    height: 1.45rem;
                    border-radius: 0.04rem;
                }
            }
            .right_msg {
                .title {
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    word-break: break-all;
                    font-size: 0.28rem;
                    font-weight: bold;
                    line-height: 0.4rem;
                    margin-bottom: 0.25rem;
                }
                .type {
                    font-size: 0.28rem;
                    color: #999999;
                    line-height: 0.4rem;
                }
            }
        }
        .price_validity {
            padding: 0.32rem;
            background: #fff;
            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 0.28rem;
                &:not(:last-of-type) {
                    margin-bottom: 0.28rem;
                }
            }
        }
        .btn_box {
            position: fixed;
            bottom: 0;
            width: 100%;
            height: 1rem;
            background: #fff;
            padding: 0.15rem 0.32rem;
            box-sizing: border-box;
            .van-button {
                width: 100%;
                height: 0.7rem;
                background: #409EFF;
                border-radius: 0.38rem;
                color: #fff;
                padding: 0;
                font-size: 0.3rem;
            }
        }
    }
</style>